import { SETTINGS } from 'app/settings';
export interface ITimezoneConfig {
  timezoneIsAPAC: boolean;
}

export interface IContactData {
  phone: string;
  option: string;
  message?: string;
  isAPAC: boolean;
}

export class SubRegionMapper {
  public predicates: ITimezoneConfig;
  public regionMap: any;
  private timezones: any = SETTINGS.REGION_MAPS.timezones;
  private contactData: any = SETTINGS.REGION_MAPS.contactData;

  constructor(timezone: string) {
    const timezoneIsAPAC: boolean = this.isTimezoneAPAC(timezone);

    this.predicates = {
      timezoneIsAPAC
    };
  }

  public getContactData(status: string): IContactData {
    const statusMessage = SETTINGS.REGION_MAPS.notificationKeys[status];
    const dataObj: IContactData = { phone: '', option: '', isAPAC: false };

    if (this.predicates.timezoneIsAPAC) {
      dataObj.isAPAC = true;
      if (status === 'seasonal-hold') {
        dataObj.message = SETTINGS.REGION_MAPS.notificationKeys['seasonal-hold-apac'];
      } else if (status === 'suspension-warning') {
        dataObj.message = SETTINGS.REGION_MAPS.notificationKeys['suspension-warning-apac'];
      } else {
        dataObj.message = SETTINGS.REGION_MAPS.notificationKeys['suspended-apac'];
      }
    } else {
      if (status === 'seasonal-hold') {
        dataObj.phone = this.contactData.seasonal_hold.phone;
        dataObj.option = this.contactData.seasonal_hold.option;
        dataObj.message = statusMessage;
      } else if (status === 'suspension-warning') {
        dataObj.phone = this.contactData.suspension.phone;
        dataObj.option = this.contactData.suspension.option;
        dataObj.message = statusMessage;
      } else {
        dataObj.phone = this.contactData.suspension.phone;
        dataObj.option = this.contactData.suspension.option;
        dataObj.message = statusMessage;
      }
    }
    return dataObj;
  }

  private isTimezoneAPAC(tz: string): boolean {
    let prefix;
    let zone;
    [prefix, zone] = tz.split('/');
    return (
      ((prefix === 'Pacific' &&
        this.timezones.apac.pacific.indexOf(zone) > -1) ||
        (prefix === 'Asia' &&
          this.timezones.apac.asia.indexOf(zone) > -1) ||
        (prefix === 'Indian' &&
          this.timezones.apac.indian.indexOf(zone) > -1) ||
        (prefix === 'Australia' &&
          this.timezones.apac.australia.indexOf(zone) > -1) ||
        (prefix === 'Etc' &&
          this.timezones.apac.etc.indexOf(zone) > -1))
    );
  }
}
